import { c as _c } from "react/compiler-runtime";
// The one grouped list (iOS inset group): rounded card, hairlines between items. Items: a label + muted value
// (Item), a tappable row (GroupRow), or a stacked item — title line, anything (a meter), muted sub line (Stack).
// Styles: book.css `.group`.
import type { ComponentProps, ReactNode } from "react";
import { Row } from "./row";

/** `busy`: its rows are loading (aria-busy: book.css draws the loader line on the card). */
export function Group(t0) {
  const $ = _c(4);
  const {
    children,
    t,
    busy
  } = t0;
  const t1 = busy || undefined;
  let t2;
  if ($[0] !== children || $[1] !== t || $[2] !== t1) {
    t2 = <ul className="group" data-t={t} aria-busy={t1}>{children}</ul>;
    $[0] = children;
    $[1] = t;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}
export function Item(t0) {
  const $ = _c(9);
  const {
    label,
    value,
    t,
    mono
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span>{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = mono ? "value mono" : "value";
  let t3;
  if ($[2] !== t2 || $[3] !== value) {
    t3 = <span className={t2}>{value}</span>;
    $[2] = t2;
    $[3] = value;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t || $[6] !== t1 || $[7] !== t3) {
    t4 = <li data-t={t}>{t1}{t3}</li>;
    $[5] = t;
    $[6] = t1;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
export function GroupRow(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <li><Row {...props} /></li>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}

/** data-* attributes pass through (tests find stacked items by them). */
export function Stack(t0) {
  const $ = _c(20);
  let children;
  let data;
  let sub;
  let title;
  let value;
  if ($[0] !== t0) {
    ({
      title,
      value,
      sub,
      children,
      ...data
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = data;
    $[3] = sub;
    $[4] = title;
    $[5] = value;
  } else {
    children = $[1];
    data = $[2];
    sub = $[3];
    title = $[4];
    value = $[5];
  }
  let t1;
  if ($[6] !== title) {
    t1 = <span className="name">{title}</span>;
    $[6] = title;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  let t2;
  if ($[8] !== value) {
    t2 = value !== undefined && <span className="value">{value}</span>;
    $[8] = value;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== t1 || $[11] !== t2) {
    t3 = <div className="line">{t1}{t2}</div>;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== sub) {
    t4 = sub !== undefined && <div className="sub">{sub}</div>;
    $[13] = sub;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== children || $[16] !== data || $[17] !== t3 || $[18] !== t4) {
    t5 = <li className="stacked" {...data}>{t3}{children}{t4}</li>;
    $[15] = children;
    $[16] = data;
    $[17] = t3;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}